import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthComponent } from '../../features/auth/pages/auth.component';
import {
  HeaderV2Component,
  NavigationButton,
} from '../../shared/components/header-v2/header-v2.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AdminService } from '../../features/user/service/admin.service';

const ADMIN_NAV_BUTTONS: ReadonlyArray<NavigationButton> = [
  {
    icon: '/public/svgs/home-w.svg',
    alt: 'app.admin.nav.dashboard',
    route: 'office',
  },
  {
    icon: '/public/svgs/list-w.svg',
    alt: 'app.admin.nav.content',
    route: 'content',
  },
  {
    icon: '/public/svgs/calendar.svg',
    alt: 'app.admin.nav.dailyFacts',
    route: 'daily-facts',
  },
  {
    icon: '/public/svgs/person.svg',
    alt: 'app.admin.nav.users',
    route: 'users',
  },
  {
    icon: '/public/svgs/patrol-w.svg',
    alt: 'app.admin.nav.patrol',
    route: 'patrol',
  },
  {
    icon: '/public/svgs/identity-id.svg',
    alt: 'app.admin.nav.identity',
    route: 'identity',
    exactRoute: true,
  },
  {
    icon: '/public/svgs/globe.svg',
    alt: 'app.admin.nav.integrationRequests',
    route: 'identity/integration-requests',
    exactRoute: true,
  },
  {
    icon: '/public/svgs/envelope.svg',
    alt: 'app.admin.nav.audience',
    route: 'audience',
  },
  {
    icon: '/public/svgs/plan.svg',
    alt: 'app.admin.nav.billing',
    route: 'billing',
  },
  {
    icon: '/public/svgs/settings.svg',
    alt: 'app.admin.nav.settings',
    route: 'settings',
  },
];

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [CommonModule, RouterOutlet, AuthComponent, HeaderV2Component],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent {
  private router = inject(Router);
  private adminService = inject(AdminService);

  public isAuthRoute = signal(false);
  public navigationButtons =
    signal<ReadonlyArray<NavigationButton>>(ADMIN_NAV_BUTTONS);
  public admin = this.adminService.admin;

  constructor() {
    this.checkRoute();
  }

  private checkRoute() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(() => {
      this.isAuthRoute.set(this.router.url.includes('/auth'));
    });
  }
}
